import React, { Component, useState, useRef, useEffect, useContext } from 'react'

import moment from 'moment'
import DayPicker, { DateUtils } from 'react-day-picker'
import 'react-day-picker/lib/style.css'
import PropTypes from 'prop-types'
import MaskedInput from 'react-text-mask'

import MonthYearPicker from '../../app/admin/views/MonthYearPicker'
import DialogBox from './DialogBox'

import { withStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import Checkbox from '@material-ui/core/Checkbox'
import MenuItem from '@material-ui/core/MenuItem'
import { Input, FormHelperText } from '@material-ui/core'


const styles = theme => ({
  root: {
  },
  textField: {
    width:'100%'
  },
  blackDisabled: {
    color:'black',
    width:'100%'
  },
  muted: {
    color: '#888'
  },
  legendRadio: {
    fontWeight: 'bold',
    color: 'black',
    marginBottom: theme.spacing(1)
  }
})  

export const validateInput = (value, required, validation) => {
  let val = value    
  if (val === null || val === undefined)
    val = ""
  if (typeof val === 'string' || val instanceof String) {
    val = val.trim()
    if (required && val.length == 0)
      return false
    if (val.length > 0) {
      if (validation === 'email') {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(String(val).toLowerCase()))
          return false
      }
    }
  }
  
  return true
}

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  function timeMask(value) {
    const chars = value.split('');
    const hours = [
        /[0-2]/,
        chars[0] == '2' ? /[0-3]/ : /[0-9]/
    ];

    const minutes = [ /[0-5]/, /[0-9]/ ];

    return hours.concat(':').concat(minutes);
}

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={timeMask}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

const InputField = ({ theme, classes, type, name, label, gutterBottom, readOnly=false, value, options, error, onChange}) => {

  const today = new Date();
  const [openDatePicker, setOpenDatePicker] = useState(false)
  const [selectedDays, setSelectedDays] = useState(null)
  const trainingSelect = new Date(today.setDate(today.getDate()+14))
  const monthPicker = new Date(trainingSelect.getFullYear(), trainingSelect.getMonth());

  const handleCloseCancel = () => {
    setOpenDatePicker(false);
  };

  const handleDayClick = (day, {selected}) => {
    // setSelectedDays(day) 
    setOpenDatePicker(false);
    onChange(moment(day).format('YYYY-MM-DD'))
  }

  const handleSelectDate = (value) => {
    setOpenDatePicker(false);
    let newDate = moment(value.year + '-' + value.month + '-01').format()
    onChange(newDate)
  }

  if (type === 'checkbox') {
    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={value}
            onChange={(event) => onChange(event.target.checked)}
            name={name}
            color="primary"
            />
        }
        label={label}
      />      
    )    
  } 
  else if (type === 'option') {
    let selectControl
    if( name !== 'category' && name !== 'course' ) {
      selectControl = (
        <Select
          value={value || ""}
          onChange={(event) => onChange(event.target.value)}
          fullWidth
          inputProps={{ readOnly: readOnly }}
          >
          { options.map((o) => o.constructor == Object ?
              <MenuItem value={o.value || o.key }>{ o.text || o.name }</MenuItem>
              :
              <MenuItem value={o}>{o}</MenuItem>
            )
          }
        </Select>    
      )
    } 
    else {
      selectControl = (
        <Select
          value={value || ""}
          onChange={(event, newValue) => onChange(event.target.value, newValue.props.item)}
          fullWidth
          inputProps={{ readOnly: readOnly }}
          >
          { options.map((o) => o.constructor == Object ?
              <MenuItem item={o} value={ o.uid }>{ o.name || o.first_name + ' ' + o.last_name }</MenuItem>
              :
              <MenuItem value={o}>{o}</MenuItem>
            )
          }
        </Select>    
      )
    }
      
    if (label)
      return (
        <FormControl fullWidth className={classes.formControl} error={error}>
         <InputLabel>{label}</InputLabel>
          { selectControl }
        </FormControl>
      )
    else
      return selectControl
  } else if (type === 'radio') {
    return (
      <FormControl component="fieldset" className={classes.formControl}>
        <FormLabel component="legend" className={classes.legendRadio}>{label}</FormLabel>
        <RadioGroup name={name} value={value || ""} 
          onChange={(event) => onChange(event.target.value)}
          row>
        
          { options.map((o) => (
            <Box display='flex' flexDirection={o.description ? 'column' : 'row'}>
              <FormControlLabel
                control={<Radio color="primary" />}
                value={o.value}
                label={
                <Box mt={o.description ? 1 : 0}>
                  <Typography variant='body1'>
                    {o.text}
                  </Typography>
                  { o.description &&
                    <Typography variant='body2' className={classes.muted}>{o.description}</Typography>
                  }
                </Box>
                }
              />
            </Box>
          ))}
          
        </RadioGroup>
      </FormControl>
    )
  } else if (type === 'date') {
    return (
      <>
        <TextField
            label={label}
            value={value ? moment(value).format('DD MMM YYYY') : ""}
            error={error}
            onClick={() => setOpenDatePicker(true)}
            InputProps={{
              readOnly: true,
            }}
            className={classes.blackDisabled}
            fullWidth
          />
          <DialogBox 
            show={openDatePicker}
            onClose={handleCloseCancel}
          >
            <DayPicker
                selectedDays={value}
                onDayClick={handleDayClick}
                disabledDays={{ before: trainingSelect }}
                month={monthPicker}
            />
          </DialogBox>
        </>
    )
  } else if (type === 'time') {
    return (
      <FormControl style={{marginTop:'8px'}}>
        <InputLabel htmlFor="formatted-text-mask-input">{label}</InputLabel>
        <Input
          value={value || ""}
          onChange={(event) => onChange(event.target.value)}
          name={name}
          inputComponent={TextMaskCustom}
        />
      </FormControl>
    )
  } else if (type === 'date_year') {
    return (
      <Box>
        <TextField
            label={label}
            value={value ? moment(value).format('MMM YYYY') : ""}
            error={error}
            onClick={() => setOpenDatePicker(true)}
            InputProps={{
              readOnly: true,
            }}
            className={classes.blackDisabled}
            fullWidth
            gutterBottom
          />

          {openDatePicker &&
            <MonthYearPicker 
              onClose={() => setOpenDatePicker(false)}
              onConfirm={handleSelectDate}
              initialData={
                {
                  month: value ? moment(value).format('MM') : '01',
                  year: value ? moment(value).format('YYYY') : moment().format('YYYY')
                }
              }
              />
          }
      </Box>
    )
  } else {
    return (
      <TextField
        label={label}
        value={value || ""}
        error={error}
        type={type}
        multiline={type=='textarea' ? true : false}
        rows={6}
        onChange={(event) => onChange(event.target.value)}
        className={classes.textField}
        margin="normal"
        fullWidth
        InputProps={{
          readOnly: readOnly,
        }}
      />      
    )    
  }
}

export default withStyles(styles)(InputField)